<script>
  import { createEventDispatcher } from 'svelte';
  import { checkmarkCircleOutline } from 'ionicons/icons/index.mjs';
  const dispatch = createEventDispatcher();
  
  function close() {
		dispatch('message', {
      type: "modal",
      modal: null
		});
  }
</script>

<div class="modal modal-sm active">
    <div class="modal-overlay"></div>
    <div class="modal-container">
        <div class="modal-header">
            <button class="btn btn-clear float-right" on:click={close} aria-label="Close"></button>
            <div class="modal-title h5">Success</div>
        </div>
        <div class="modal-body">
          <div class="empty">
              <div class="empty-icon">
                  <i class="svg">{@html checkmarkCircleOutline.md}</i>
              </div>
              <p class="empty-title h5">Form submitted</p>
          </div>
        </div>
    </div>
</div>

<style>
    .modal-container .modal-header {
        padding-bottom: 0;
    }
    .modal-container .modal-body {
        padding-top: 0;
    }
</style>